import '../palette/palette.scss';

import Kbd, { modKeyLabel } from '@/components/reusable/kbd';
import { useHelpCapabilities } from '@/hooks/queries/help-centre/use-help-queries';

import { HC_COPY } from '../HelpCentre.Copy';
import { paletteStore } from '../palette/palette-store';
import { useOpenHelp } from '../use-open-help';

export const QuestionGlyph = () => (
	<svg
		width='16'
		height='16'
		viewBox='0 0 24 24'
		fill='none'
		stroke='currentColor'
		strokeWidth='2'
		strokeLinecap='round'
		strokeLinejoin='round'
		aria-hidden='true'
		focusable='false'
	>
		<circle
			cx='12'
			cy='12'
			r='9.5'
		/>
		<path d='M9.2 9.2a2.9 2.9 0 0 1 5.6 1c0 1.9-2.8 2.6-2.8 2.6M12 16.8h.01' />
	</svg>
);

/**
 * Header entry points: the palette trigger (always — "Go to" works without a Help Centre) and the
 * "?" that opens this page's guides (only when the capability handshake says guides exist).
 */
const HelpHeaderActions = () => {
	const caps = useHelpCapabilities();
	const openHelp = useOpenHelp();
	const triggerLabel = caps.available ? HC_COPY.palette.trigger : 'Go to page';

	return (
		<>
			<button
				type='button'
				className='hc-header-search'
				onClick={() => paletteStore.open()}
				aria-label={`${triggerLabel} (${modKeyLabel()} K)`}
				aria-haspopup='dialog'
			>
				<svg
					width='15'
					height='15'
					viewBox='0 0 24 24'
					fill='none'
					stroke='currentColor'
					strokeWidth='2'
					strokeLinecap='round'
					aria-hidden='true'
					focusable='false'
				>
					<circle
						cx='11'
						cy='11'
						r='7'
					/>
					<path d='M20 20l-3.5-3.5' />
				</svg>
				<span className='hc-header-search__label'>{triggerLabel}</span>
				<span
					className='hc-header-search__kbd'
					aria-hidden='true'
				>
					<Kbd>{modKeyLabel()}</Kbd>
					<Kbd>K</Kbd>
				</span>
			</button>
			{caps.available && openHelp ? (
				<button
					type='button'
					className='hc-header-help'
					onClick={() => openHelp()}
					aria-label={HC_COPY.context.trigger}
					title={HC_COPY.context.trigger}
					data-testid='header-help-button'
				>
					<QuestionGlyph />
				</button>
			) : null}
		</>
	);
};

export default HelpHeaderActions;
